import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_PROVIDER_DEMO_IEAM_5 = {
  title: "Application validation\n and lifecycle progression ",
  subtitle: "Use case Provider demo",
  text: "Once completed, the application is validated\nand lands in 'package validated state'. The user\ncan take the application through its life cycle.\n\nDeployed to Sandbox -> Deployed to UAT ->\nUAT Certified -> Published.",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_110"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_108"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/IEAM/IEAM_Use_case_provider_demo_screens_01_BG.png",
  rightSideImage: "ENG/IEAM/IEAM_Use_case_provider_demo_screens_05.png",
};
